import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class LedgerContractPDF extends BaseUseCase {
    constructor(LedgerRepo) {
        super();
        this.LedgerRepo = LedgerRepo;
    }
    async fetchResult(req) {
        return await this.LedgerRepo.contractPDF(req);
    }
}
export default LedgerContractPDF;
